import CustomFooter from "../views/footer";
import React from "react";
import { Layout } from "antd";
import Navbar from "../components/navbar";
import Projects from "../views/projects";
import Products from "../views/products";
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";

const { Header, Footer, Content } = Layout;

function ProjectsPage() {
    return (
        <Layout className="flex flex-col min-h-screen bg-white">
            <Header className={' h-0 bg-transparent w-full align-middle justify-center fixed top-1.5 z-30 p-0'}>
                <Navbar/>
            </Header>
            <Content className="space-y-4 flex-1 overflow-y-auto overflow-x-hidden justify-center">
                <Projects />
                <Products />
                <WhatsAppFloatingButton/>
            </Content>

            <Footer className="p-0">
                <CustomFooter />
            </Footer>
        </Layout>
    );
}

export default ProjectsPage;

